module.exports = __webpack_public_path__ + "img/vol06_character_thumb01.6dd672f3.png";